
$(document).ready(function() {

  if ($('.admin-modal-status-radios')) {
    // Show the reasons, comments and submit
    $('#statusModal .admin-modal-status-radios input[name=status]').on('change', function() {


      $('#statusModal .admin-status-wrapper.d-none').removeClass('d-none');

      if($(this).val() === "pending") {
        $('#statusModal .admin-status-wrapper').addClass('d-none');
      }
    });
  }
});
